
























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Validation}  from 'vuelidate'
import {getValidationMessages} from '@/lib/validation/validationMessages.ts'


@Component
export default class PxTextArea extends Vue {
  @Prop() value!: string | null | undefined;
  @Prop({default: "Enter text here."}) placeholder!: string | null;
  @Prop() description!: string | null;
  @Prop() titleText!: string;
  @Prop() id!: string;
  @Prop({default: 'text'}) inputType!: string;
  @Prop() validation!: Validation;
  @Prop({default: false}) disabled!: boolean;
  @Prop() quickHelpText!: string | null;
  @Prop({default: false}) isHorizontal!: boolean;
  @Prop({default: 4}) labelColsMd!: number;
  @Prop({default: false}) minimal!: boolean;

  // Seems to be necessary to structure this way to capture proper 'this'
  get inputValue(): string | null | undefined {
    return this.value
  }

  set inputValue(v: string | null | undefined) {
    this.$emit('input', v)
  }

  get isValid(): boolean | null {
    if (this.validation && this.validation.$dirty) {
      return !this.validation.$error
    }
    return null
  }

  get showInvalidFeedback(){
    return this.validationText !== null && this.validationText !== ''
  }

  get validationText(): string | null {
    // Show messages only when field is both invalid & dirty
    if (this.validation && this.validation.$anyError) {
      return getValidationMessages(this.validation)
    } else {
      return null
    }
  }

  blur() {
    this.setPageDirty();
    this.$emit('blur')
  }

  setPageDirty(): void {
    if (this.validation){
      this.validation.$touch()
    } else {
      console.debug("No validation rules available:", this.id)
    }
  }

}
